module.exports = __webpack_public_path__ + "static/media/container-v.e55db6f1.png";